import { RfqStatus } from '@luminovo/api-contracts';
import { assertUnreachable } from '@luminovo/commons';
import { colorSystem, Tag } from '@luminovo/design-system';
import { transEnum } from '@luminovo/frontend-utils';
import { rfqStatusTranslations } from '@luminovo/sourcing-core';

export function rfqStatusColor(status: RfqStatus): keyof typeof colorSystem {
    switch (status) {
        case RfqStatus.RequestInDraft:
            return 'blue';
        case RfqStatus.QuotationInProgress:
            return 'primary';
        case RfqStatus.QuotationAvailable:
            return 'green';
        case RfqStatus.NoQuotation:
            return 'neutral';
        case RfqStatus.NoOrder:
        case RfqStatus.PaymentFailed:
            return 'red';
        case RfqStatus.OrderPlaced:
            return 'green';
        case RfqStatus.OrderConfirmed:
            return 'green';
        case RfqStatus.OrderInProduction:
            return 'primary';
        case RfqStatus.OrderShipped:
        case RfqStatus.OrderInProcurement:
            return 'green';
        default:
            return assertUnreachable(status);
    }
}

export const StyledRfqStatusBox = ({
    rfqStatus,
    showEllipsis,
}: {
    rfqStatus: RfqStatus;
    showEllipsis?: boolean;
}): JSX.Element => {
    return (
        <Tag
            attention={'low'}
            color={rfqStatusColor(rfqStatus)}
            label={transEnum(rfqStatus, rfqStatusTranslations)}
            showEllipsis={showEllipsis}
        />
    );
};
